import Instance from '../../../Helper/axios';
import { URL, URLTEST } from '../../../Helper/baseURL';

export const updateRetriever = (id,ref_no) => {
    return Instance.post(URL + 'report/ControlParcel/updateRetriever',{
        ref_no,
        idShop: id,
    });
};
